import { render } from "./databasePage.vue?vue&type=template&id=0788b29f"
import script from "./databasePage.vue?vue&type=script&lang=js"
export * from "./databasePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__